import React from 'react'

import usePortalCopy from 'hooks/usePortalCopy'
import usePortalJump from 'hooks/usePortalJump'

import {
    Banner,
    CtaButton,
    Description,
    Logo,
    TextSection,
} from './ApprovalOemPortalJumpCta.styled'
import { OemPortalBrandKey, oemPortalBrands } from './oemPortalBrands'

interface ApprovalOemPortalJumpCtaProps {
    readonly applicationUuid: string
    readonly brand?: OemPortalBrandKey
}

export default function ApprovalOemPortalJumpCta({
    applicationUuid,
    brand = 'brp',
}: ApprovalOemPortalJumpCtaProps): React.ReactElement {
    const { colors, logo, logoAlt, approval, targetPortal, interstitialLabel } =
        oemPortalBrands[brand]

    const { hasCopy, isLoading, triggerCopy } = usePortalCopy(
        applicationUuid,
        targetPortal,
    )

    const handleClick = usePortalJump(hasCopy, triggerCopy, interstitialLabel)

    return (
        <Banner $background={colors.banner}>
            <Logo src={logo} alt={logoAlt} />
            <TextSection>
                <Description $color={colors.bannerText}>
                    {approval.description}
                </Description>
            </TextSection>
            <CtaButton
                variant="primaryOutlined"
                disabled={isLoading}
                onClick={handleClick}
                $background={colors.buttonBackground}
                $backgroundHover={colors.buttonBackgroundHover}
                $color={colors.buttonText}
            >
                {hasCopy ? 'Open Application' : approval.ctaLabel}
            </CtaButton>
        </Banner>
    )
}
